import { useNuxtApp } from "#app";
import { BaseService } from "../base/base.service";
import type { IModelResponse } from "../base/dto/base.dto";
import { ConversationHistoryRepository } from "./conversation-history.repository";
import {
  ModelChatHistory,
  ModelContact,
  type IModelManualSetStateRequest,
  type IModelManualSetStateResponse,
  type IModelManualHandoffRequest,
  type IModelManualHandoffResponse,
} from "./dto/conversation-history.dto";

export class ConversationHistoryService extends BaseService {
  private conversationHistoryRepository = new ConversationHistoryRepository(
    this.api,
    this.configService
  );

  async getContactList(params: any): Promise<IModelResponse<ModelContact[]>> {
    let dataResult: IModelResponse<ModelContact[]> = {
      data: [],
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.conversationHistoryRepository.getContactList(
        params
      );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelContact(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        console.log(
          "getContactList response:",
          resData,
          "dataResult:",
          dataResult
        );
      }
    } catch (err: any) {
      console.log(err, ConversationHistoryService.name);
    }
    return dataResult;
  }

  async getChatHistoryList(params: any): Promise<IModelResponse<ModelChatHistory[]>> {
    let dataResult: IModelResponse<ModelChatHistory[]> = {
      data: [],
      nextCursor: null,
      hasMore: false,
    };
    const { $functions } = useNuxtApp();
    try {
      const res = await this.conversationHistoryRepository.getChatHistoryList(
        params
      );
      const resData = res.data.value;
      if ($functions.isValidResponse(resData)) {
        const dataList = (resData.data || []).map((e) => new ModelChatHistory(e));
        dataResult.data = dataList;
        dataResult.totalItems = resData.totalItems;
        // Cursor-based pagination — see BE: src/message-presenter/bll/chat-history-query.bll.ts
        dataResult.nextCursor = resData.nextCursor ?? null;
        dataResult.hasMore = Boolean(resData.hasMore);
        console.log(
          "getChatHistoryList response:",
          resData,
          "dataResult:",
          dataResult
        );
      }
    } catch (err: any) {
      console.log(err, ConversationHistoryService.name);
    }
    return dataResult;
  }

  // Back-office handoff to a human agent (ConnectX setState=agent). The BE
  // returns the raw ManualSetStateResponse (no SUCCESS envelope); errors are
  // surfaced as toasts by useApi's onResponseError.
  async manualSetState(
    params: IModelManualSetStateRequest
  ): Promise<IModelManualSetStateResponse | null> {
    try {
      const res = await this.conversationHistoryRepository.manualSetState(params);
      if (res.error.value) return null;
      return res.data.value ?? null;
    } catch (err: any) {
      console.log(err, ConversationHistoryService.name);
      return null;
    }
  }

  // Webchat / mobile webview handoff (TG-social-webchat-service). Errors are
  // surfaced as toasts by useApi's onResponseError.
  async manualHandoffWebchat(
    params: IModelManualHandoffRequest
  ): Promise<IModelManualHandoffResponse | null> {
    try {
      const res = await this.conversationHistoryRepository.manualHandoffWebchat(params);
      if (res.error.value) return null;
      return res.data.value ?? null;
    } catch (err: any) {
      console.log(err, ConversationHistoryService.name);
      return null;
    }
  }
}
